var map = {
	"./arabia/qizhi.png": 796,
	"./britain/qizhi.png": 797,
	"./byzantium/qizhi.png": 798,
	"./china/qizhi.png": 799,
	"./egypt/qizhi.png": 800,
	"./france/qizhi.png": 801,
	"./germany/qizhi.png": 802,
	"./greece/qizhi.png": 803,
	"./japan/qizhi.png": 804,
	"./korea/qizhi.png": 805,
	"./ottomanEmpire/qizhi.png": 806,
	"./rome/qizhi.png": 807,
	"./spain/qizhi.png": 808,
	"./vikings/qizhi.png": 809
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 795;